export enum ETenantCode {
  CAREPLUS = 'careplus',
  FLEURY = 'fleury',
  ACCAMARGO = 'accamargo',
  EINSTEIN = 'einstein',
}
